// Наглядная полоска распределения долей: сегменты по pct (для пресетов платежей).
const SEG = ['var(--vi)', 'var(--cy)', 'var(--gold)', 'var(--grn)', 'var(--red)'];

export function PctBar({ items }: { items: { pct: number; label?: string }[] }) {
  return (
    <div
      style={{
        display: 'flex',
        height: 10,
        borderRadius: 5,
        overflow: 'hidden',
        background: 'var(--gl)',
      }}
    >
      {items.map((it, i) => (
        <div
          key={i}
          title={`${it.label ?? ''} ${it.pct}%`.trim()}
          style={{ width: `${Math.max(0, it.pct)}%`, background: SEG[i % SEG.length] }}
        />
      ))}
    </div>
  );
}
